import styles from './style.module.scss';

export const Bottom = () => {
  return (
    <div className={styles.bottom}>
      <a
        style={{ color: '#54BECC' }}
        target="__blank"
        href="https://github.com/limuen"
      >
        GitHub
      </a>
    </div>
  );
};
